import { EXPENSES_ENDPOINTS, GroupedExpensesResponse } from "@/features/vouchers";
import type { ExpensesResponse } from "@/features/vouchers/types/expense.type";
import { fetcher } from "@/shared/lib/fetcher.client";

export const getExpenses = async (voucherEmployeeId?: string): Promise<ExpensesResponse> => {
  const params = voucherEmployeeId
    ? { q: { voucher_employee_id_eq: voucherEmployeeId }, per_page: 999 }
    : { per_page: 999 };
  const response = await fetcher.get<ExpensesResponse>(EXPENSES_ENDPOINTS.GET_EXPENSES, { params });
  return response.data;
};

export const getRecentExpenses = async (): Promise<GroupedExpensesResponse> => {
  const response = await fetcher.get<GroupedExpensesResponse>(EXPENSES_ENDPOINTS.GET_RECENT_EXPENSES);
  return response.data;
};
